import React from 'react';
import { Banner } from '@/components/uikit';
import { Container, Grid } from '@material-ui/core';

interface ParentProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  hideBanner?: boolean;
}

const MainLayout = ({ children, style, hideBanner }: ParentProps) => {
  return (
    <>
      {!hideBanner && <Banner type="app-install" right={16} />}
      <Container style={style} maxWidth="sm" className="container">
        <Grid className="grid">{children}</Grid>
      </Container>
    </>
  );
};

export default MainLayout;
